import { gql } from "@apollo/client";

export const GET_FILE = gql`
  query GetFile($id: ID!, $authorId: String!) {
    file(id: $id, authorId: $authorId) {
      id
      authorId
      fileCategory
      type
      mimeType
      url
      publicUrl
      key
      size
      description
      summary
      data
      aiFileId
      status
      isPublic
      uploadedAt
      createdAt
      updatedAt
      docType
      version
      isCurrent
      supersedesFileId
      ref {
        id
        collection
      }
    }
  }
`;

export const GET_FILE_SIGNED_URL = gql`
  query FileSignedUrl($input: FileSignedUrlInput!) {
    fileSignedUrl(input: $input) {
      signedUrl
    }
  }
`;

export const GET_FILE_UPLOAD_URL = gql`
  query FileUploadUrl($input: FileUploadUrlInput!) {
    fileUploadUrl(input: $input) {
      uploadUrl
      key
    }
  }
`;

export const GET_FILES = gql`
  query GetFiles($input: FilesInput!) {
    files(input: $input) {
      total
      files {
        id
        authorId
        fileCategory
      type
      mimeType
      url
      publicUrl
      key
        size
        description
        summary
        data
        aiFileId
        status
        isPublic
        uploadedAt
        createdAt
        updatedAt
        docType
        version
        isCurrent
        supersedesFileId
        ref {
          id
          collection
        }
        domain
        isSystem
      }
    }
  }
`;
